export class CertificateResponseDTO {
	successMessage : string;
    errorMessage: string;
}
